import React, { useEffect, useState } from 'react'

import { authService } from '../api/services/auth'

import { UserContext, type UserContextType } from './user-context-definition'

import type { User } from '../api/types'

type UserProviderProps = {
  children: React.ReactNode
}

export const UserProvider = ({ children }: UserProviderProps): React.JSX.Element => {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  const fetchUser = async (): Promise<void> => {
    try {
      if (!authService.isAuthenticated()) {
        setUser(null)
        return
      }

      const userData = await authService.getCurrentUser()
      setUser(userData)
    } catch (error) {
      console.error('Failed to fetch user:', error)
      setUser(null)
      // Clear invalid tokens
      authService.logout()
    } finally {
      setLoading(false)
    }
  }

  const refreshUser = async (): Promise<void> => {
    setLoading(true)
    await fetchUser()
  }

  useEffect(() => {
    fetchUser()
  }, [])

  const contextValue: UserContextType = {
    user,
    loading,
    refreshUser,
  }

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
}